export default "__VITE_ASSET__Df9wyKIV__"